<template>
  <div class="head-container">
    <div class="tab-content">
      <a href="http://www.procaregroup.com/" class="logo-box">
        <img src="@/assets/img/logo.png" alt="logo" class="tab-logo" @click="goIndex" />
      </a>
      <div class="middle-box">
        <a href="http://www.procaregroup.com/" class="tab-title">首页</a>
        <div class="tab-title">
          集团介绍
          <div class="back-child">
            <div class="child-box">
              <img src="@/assets/img/nav1.jpg" alt="柏瑞康" />
              <div class="left-child">
                <a class="c-list" href="http://www.procaregroup.com/a/company">关于我们</a>
                <a class="c-list" href="http://www.procaregroup.com/a/chanyejiqun">产业集群</a>
                <a class="c-list" href="http://www.procaregroup.com/a/redianzixun">热点咨询</a>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="tab-title">内部公告</div> -->
        <div class="tab-title">
          政策公告
          <div class="back-child">
            <div class="child-box">
              <img src="@/assets/img/nav2.jpg" alt="柏瑞康" />
              <div class="left-child">
                <a class="c-list" href="http://www.procaregroup.com/a/zhengcejiedu">政策解读</a>
                <a class="c-list" href="http://www.procaregroup.com/a/tashanzhishi">他山之石</a>
                <a class="c-list" href="http://www.procaregroup.com/a/hangyebiaozhun">行业标准</a>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-title one-title">
          大健康行业资询
          <div class="back-child">
            <div class="child-box">
              <img src="@/assets/img/nav3.jpg" alt="柏瑞康" />
              <div class="left-child">
                <a class="c-list" href="http://www.procaregroup.com/a/hlzk">关于汇林智库</a>
                <a class="c-list" href="http://www.procaregroup.com/a/chanyeyanjiuyuan">三大产业研究院</a>
                <a class="c-list" href="http://www.procaregroup.com/a/zhihuichaoshi">智慧超市</a>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-title one-title">
          大健康产业实践
          <div class="back-child">
            <div class="child-box">
              <img src="@/assets/img/nav4.jpg" alt="柏瑞康" />
              <div class="left-child">
                <a
                  class="c-list"
                  href="http://www.procaregroup.com/a/brkjk"
                >关于柏瑞康健康</a>
                <a class="c-list" href="http://www.procaregroup.com/a/xiangmujieshao">项目介绍</a>
                <a class="c-list" href="http://www.procaregroup.com/a/shenghuoyuandi">生活园地</a>
                <a class="c-list" href="http://www.procaregroup.com/a/hulibiaobin">护理人风采</a>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-title two-title">
          大健康人才教育培训
          <div class="back-child">
            <div class="child-box">
              <img src="@/assets/img/nav5.jpg" alt="柏瑞康" />
              <div class="left-child">
                <router-link class="c-list" :to="{ name: 'courseList' }">课程列表</router-link>
                <router-link class="c-list" :to="{ name: 'onlineExam' }">在线考试</router-link>
                <router-link class="c-list" :to="{ name: 'remoteEducation' }">远程教育</router-link>
                <router-link :to="{ name: 'studyRoom' }" class="c-list">柏瑞康书斋</router-link>
                <router-link class="c-list" :to="{ name: 'schoolShow' }">学校风采</router-link>
                <router-link class="c-list" :to="{ name: 'personalCenter' }">个人中心</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-box">
        <!-- <a class="tab-title" href="http://www.procaregroup.com/hulibiaobing/">护理园地</a> -->
        <a class="tab-title" href="http://www.procaregroup.com/rencailinian/">
          集团招聘
          <div class="back-child">
            <div class="child-box">
              <img src="@/assets/img/nav.jpg" alt="柏瑞康" />
              <div class="left-child">
                <a class="c-list" href="http://www.procaregroup.com/rencailinian/">人才理念</a>
                <a class="c-list" href="http://www.procaregroup.com/zhaopin/">人员招聘</a>
              </div>
            </div>
          </div>
        </a>
        <a class="tab-title" href="http://www.procaregroup.com/contact/">联系我们</a>
        <a class="tab-title" href="http://www.procaregroup.com/">员工入口</a>
        <div class="tab-title line">|</div>
        <i class="iconfont el-icon-search"></i>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'headTab',
  data() {
    return {};
  },
  methods: {
    goIndex() {
      this.$router.push({ path: '/' });
    }
  }
};
</script>
<style lang="scss" scoped>
.tab-content {
  position: fixed;
  z-index: 2000;
  top: 0;
  transition: all 0.5s;
  // display: flex;
  // justify-content: space-between;
  width: 100%;
  // min-width: 1400PX;
  padding: 0 60PX;
  background-color: #ffffff;
}
.logo-box {
  float: left;
  // width: 20%;
}
.middle-box {
  // width: 46%;
  margin-left: 7vw;
  float: left;
  display: flex;
  justify-content: space-between;
}
.right-box {
  // width: 18%;
  float: right;
  display: flex;
  justify-content: space-between;
  .iconfont {
    position: relative;
    top: 1PX;
    margin-left: 2vw;
    line-height: 116PX;
    color: #888;
  }
  .tab-title {
    font-size: 14PX;
    color: #444444;
  }
}
.tab-title {
  position: relative;
  margin-left: 2vw;
  line-height: 122PX;
  font-size: 18PX;
  color: #444444;
  cursor: pointer;
  &:hover {
    color: #f1a373;
    .back-child {
      display: flex;
    }
  }
}
.one-title {
  .back-child {
    right: -34PX;
  }
}
.two-title {
  .back-child {
    right: -2PX;
  }
}
.line {
  font-size: 0.8vw;
  color: #888;
}
.back-child {
  position: absolute;
  display: none;
  right: -88PX;
  top: 122PX;
  padding-top: 4PX;
  z-index: 999;
}
.child-box {
  display: flex;
  width: 434PX;
}
.left-child {
  width: 152PX;
  padding: 26PX 30PX 18PX 28PX;
  background-color: #ffffff;
  .c-list {
    position: relative;
    display: block;
    padding-bottom: 6PX;
    font-size: 14PX;
    color: #666666;
    line-height: normal;
    cursor: pointer;
    &::before {
      position: absolute;
      display: none;
      top: 6PX;
      left: -16PX;
      width: 3PX;
      height: 9PX;
      background-color: #f29865;
      content: '';
    }
    &:hover {
      color: #f29865;
      &::before {
        display: block;
      }
    }
  }
}
@media screen and (max-width: 1600PX) {
  .tab-title {
    font-size: 16PX;
  }
}
@media screen and (max-width: 1300PX) {
  .tab-title {
    margin-left: 1.6vw;
  }
}
@media screen and (max-width: 1160PX) {
  .right-box {
    float: right;
  }
}
@media screen and (max-width: 1500PX) {
  .tab-content {
    padding: 0 30PX;
  }
  .middle-box {
    margin-left: 4vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/headTab.vue